import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/productReview';
import * as productReviewTypes from '@redux/actions/productReview/productReviewTypes';
import { getAsObservable } from '@services/genericService';
import { deepCopy } from '@utils/utility';

import * as config from './config';

export const getProductsNameEpic = (action$) =>
  action$.pipe(
    ofType(productReviewTypes.GET_PRODUCTS_NAME),
    switchMap((action) => {
      const params = {
        page: action.payload.page,
        pageSz: action.payload.pageSz
      };

      return getAsObservable(config.ACTION_GET_PRODUCTS_NAME, params).pipe(
        map((res) => {
          if (res.status === 200) {
            return actions.getProductsNameSuccess(deepCopy(res.data));
          } else {
            return actions.getProductsNameFailed('Failed');
          }
        })
      );
    })
  );
